import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import type {
  GenerateProductVariantWeightsAndDimensionsRequestDto,
  GenerateProductVariantWeightsAndDimensionsResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { generateProductVariantWeightsAndDimensions } from '../../../productsSlice';

function useGenerateProductVariantWeightsAndDimensions() {
  const dispatch = useAppDispatch();

  const generateWeightsAndDimensions = useCallback(
    async (
      requestDto: GenerateProductVariantWeightsAndDimensionsRequestDto,
    ): Promise<GenerateProductVariantWeightsAndDimensionsResponseDto> => {
      const result = await dispatch(
        generateProductVariantWeightsAndDimensions(requestDto),
      );
      return unwrapResult(result);
    },
    [dispatch],
  );

  return { generateWeightsAndDimensions };
}

export default useGenerateProductVariantWeightsAndDimensions;
